import type { Theme, ThemeOptions } from '@mui/material/styles';

import { createTheme } from '@mui/material/styles';

import { getBaseTheme, wcfGUIPalette, wcfGUITypography } from '@egr/xbox/egr-gui-elements/Helper/MUIOverrides';
import { OpenSansFontFaces } from '@egr/xbox/fonts/openSans/OpenSansImport';

export const mainPrimaryColor: string = '#4F4F4F';
export const mainSecondaryColor: string = '#F7A600';

const baseThemeLight: Theme = getBaseTheme(wcfGUIPalette(mainPrimaryColor, mainSecondaryColor));

const customTypography = {
    ...wcfGUITypography,
    caption: {
        color: '#999999',
    },
    footer: {
        fontSize: 11,
        color: '#212121',
    },
};

const defaultThemeOptions: ThemeOptions = {
    ...baseThemeLight,
    typography: customTypography,
    components: {
        MuiCssBaseline: {
            styleOverrides: OpenSansFontFaces,
        },

        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: 14,
                },
            },
        },
        MuiMobileStepper: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                },
                dots: {
                    margin: '0 10px',
                },
            },
        },
    },
};

declare module '@mui/material/styles' {
    interface TypographyVariants {
        footer: React.CSSProperties;
    }

    // allow configuration using `createTheme()`
    interface TypographyVariantsOptions {
        footer?: React.CSSProperties;
    }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        footer: true;
    }
}

export default createTheme(defaultThemeOptions);
